import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Persists the active team ID across page reloads so that a user who
 * belongs to multiple teams (e.g., a consultant invited into multiple
 * bank tenants) can explicitly select which tenant their API calls
 * operate against. Without this, useTeamId falls back to "first owned
 * team" which is safe but not intentional — and with no UI affordance
 * the user had no way to see or change what they were acting on.
 */

interface ActiveTeamState {
  activeTeamId: string | null;
  setActiveTeamId: (teamId: string | null) => void;
  clear: () => void;
}

export const useActiveTeamStore = create<ActiveTeamState>()(
  persist(
    (set) => ({
      activeTeamId: null,
      setActiveTeamId: (teamId) => set({ activeTeamId: teamId }),
      clear: () => set({ activeTeamId: null }),
    }),
    {
      name: 'active-team-storage',
    },
  ),
);
